export default {
  seeOptions: {
    id: 'comparison_tool_modal_cta',
    defaultMessage: 'See options',
  },
  startingFrom: {
    id: 'card_starting_from',
    defaultMessage: 'Starting from',
  },
}
